import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const rejectionsTDR = async (
  query = {},
  page = 1,
  pageSize = 10,
  _sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(query).params;
  params['page[number]'] = page;
  params['page[size]'] = pageSize;
  if (search) params['filter[search]'] = search;

  return await httpClient.get(
    exportCSV ? 'rejections_tdr/export/' : 'rejections_tdr/',
    {
      params: params,
    },
  );
};

const getCounters = async (query) => {
  return await httpClient.get(
    `rejections_tdr/counters/`,
    makeFilterParams(query),
  );
};

const projectSelector = async () => {
  return await httpClient.get('rejections_project_selector/');
};

const roleSelector = async (project_id) => {
  return await httpClient.get('rejections_project_position_selector/', {
    params: { 'filter[proyecto]': project_id },
  });
};

const getTDR = async (id) => await httpClient.get(`rejections_tdr/${id}`);

const reactivate = async (id) =>
  await httpClient.put(`rejections_tdr/${id}/reactivate/`);

const confirm = async (id) =>
  await httpClient.put(`rejections_tdr/${id}/confirm/`);

const getRoles = async () => await httpClient.get('rejections_tdr/get_groups/');

const getUsers = async (project_id, rol_id) =>
  await httpClient.get(
    'rejections_tdr/get_users/',
    makeFilterParams({
      proyecto: project_id,
      rol: rol_id,
    }),
  );

const getDocuments = async (id) =>
  await httpClient.get(`rejections_tdr/${id}/get_documents/`);

const assign = async (id, data) =>
  await httpClient.put(`rejections_tdr/${id}/assign/`, data);

const rejectionsCTM = async (
  query = {},
  page = 1,
  pageSize = 10,
  _sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(query).params;
  params['page[number]'] = page;
  params['page[size]'] = pageSize;
  if (search) params['filter[search]'] = search;

  return await httpClient.get(
    exportCSV ? 'rejections_ctm/export/' : 'rejections_ctm/',
    {
      params: params,
    },
  );
};

const getCountersCTM = async (query) => {
  return await httpClient.get(
    `rejections_ctm/counters/`,
    makeFilterParams(query),
  );
};

const getCTM = async (id) => await httpClient.get(`rejections_ctm/${id}`);

const reactivateCTM = async (id) =>
  await httpClient.put(`rejections_ctm/${id}/reactivate/`);

const confirmCTM = async (id) =>
  await httpClient.put(`rejections_ctm/${id}/confirm/`);

const getRolesCTM = async () =>
  await httpClient.get('rejections_ctm/get_groups/');

const getUsersCTM = async (project_id, rol_id) =>
  await httpClient.get(
    'rejections_ctm/get_users/',
    makeFilterParams({
      proyecto: project_id,
      rol: rol_id,
    }),
  );

const getDocumentsCTM = async (id) =>
  await httpClient.get(`rejections_ctm/${id}/get_documents/`);

const assignCTM = async (id, data) =>
  await httpClient.put(`rejections_ctm/${id}/assign/`, data);

export {
  rejectionsTDR,
  getCounters,
  projectSelector,
  roleSelector,
  getTDR,
  reactivate,
  confirm,
  getRoles,
  getUsers,
  getDocuments,
  assign,
  rejectionsCTM,
  getCountersCTM,
  getCTM,
  reactivateCTM,
  confirmCTM,
  getRolesCTM,
  getUsersCTM,
  getDocumentsCTM,
  assignCTM,
};
